import { create } from '@thoughtspot/logger';
const logger = create('microfrontends-util');
export var Microfrontend;
(function (Microfrontend) {
    Microfrontend["EUREKA"] = "eureka";
    Microfrontend["EMBED_DEV_PORTAL"] = "embed-dev-portal";
    Microfrontend["HOME"] = "home";
    Microfrontend["DATA_MODEL"] = "data-model";
    Microfrontend["ADMIN"] = "admin";
    Microfrontend["SEEKWELL"] = "seekwell";
    Microfrontend["TEAMS"] = "teams";
    Microfrontend["COMS"] = "coms";
    Microfrontend["MONITOR"] = "monitor";
    Microfrontend["GLOBAL_NAV"] = "global-nav";
    Microfrontend["SPOTTER"] = "spotter";
    Microfrontend["CONV_ASSIST"] = "conv-assist";
    Microfrontend["EDGE"] = "edge";
    Microfrontend["COPILOT"] = "copilot";
    Microfrontend["WORKSHEET_V2"] = "worksheet-v2";
    Microfrontend["QUERY_VISUALIZER"] = "query-visualizer";
    Microfrontend["EMBRACE"] = "embrace";
    Microfrontend["CAPTAIN"] = "captain";
    Microfrontend["ONBOARDING"] = "onboarding";
    Microfrontend["SAGE_COACH"] = "sage-coach";
    Microfrontend["STATUS"] = "status";
    Microfrontend["EUREKA_DATA_MODEL"] = "eureka-data-model";
    Microfrontend["NAVIGATION"] = "navigation";
    Microfrontend["LIVEBOARD"] = "liveboard";
    Microfrontend["ARSENAL"] = "arsenal";
    Microfrontend["AURORA"] = "aurora";
    Microfrontend["SPARKFLOW"] = "sparkflow";
    Microfrontend["FULL_USER_JOURNEY"] = "full-user-journey";
    Microfrontend["AGENT_DB"] = "agent-db";
    Microfrontend["DATAAPPS"] = "dataapps";
    Microfrontend["SPOTTER_BENCHMARK"] = "spotter-benchmark";
})(Microfrontend || (Microfrontend = {}));
export const MFE_CDN_HOSTS = Object.freeze({
    dev: 'https://mfe-cdn.thoughtspotdev.cloud',
    staging: 'https://mfe-cdn.thoughtspotstaging.cloud',
    prod: 'https://mfe-cdn.thoughtspot.cloud',
});
export const MFE_MANIFEST_PATH = '/mfe-registry/v1/manifest.json';
export const getMfeManifestUrl = (env) => `${MFE_CDN_HOSTS[env]}${MFE_MANIFEST_PATH}`;
export const MFE_ENTRY_PATH_PATTERN = /^[a-z0-9-]+\/\d{4}\.\d{2}\.\d{2}-\d+$/;
export const MFE_ASSET_FILE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;
export const getMfeAssetUrl = (cdnOrigin, entryPath, file) => `${cdnOrigin}/${entryPath}/${file}`;
export function logMicroFrontendsDebugInfo() {
    const microfrontends = window?.blink?.microfrontends;
    if (microfrontends?.isCdnEnabled) {
        logger.debug(`CDN Enabled: ${microfrontends.isCdnEnabled}`);
    }
    if (microfrontends?.cdnBasePath) {
        logger.debug(`CDN Base Path: ${microfrontends.cdnBasePath}`);
    }
    Object.values(Microfrontend).forEach(mfe => {
        if (microfrontends?.[mfe]?.releaseVersion) {
            logger.debug(`${mfe} version: ${microfrontends?.[mfe]?.releaseVersion}, path: ${microfrontends?.[mfe]?.path}, js: ${microfrontends?.[mfe]?.js}, css: ${microfrontends?.[mfe]?.css}`);
        }
    });
}
//# sourceMappingURL=index.js.map